<template>
  <router-view/>
</template>
<script lang="js">
import { ref } from 'vue'
import { mapState } from 'vuex'
export default {
  name: 'App',

  computed: {
    ...mapState(['device'])
  },

  beforeUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  },

  created () {
    console.log('Timeout is set to refresh entire page in 12 hours')
    this.timeout = setTimeout(() => {
      if (this.device && this.device.code) {
        window.location.href = 'https://collab-tv.com/#/?code=' + this.device.code
      } else {
        window.location.reload()
      }
    }, 12 * 60 * 60 * 1000)
  },

  setup () {
    const timeout = ref(null)
    document.title = 'Mural Digital v2.3.4'

    return {
      timeout
    }
  }
}
</script>
